import React, { Component, useState, Fragment } from "react";
import PersonalContext from "./PersonalContext";
import successful from "../../images/checked.svg";
import { CurrencyUtils } from "../../utils";
import { DATETHAI_FORMAT, DATETIME_PAYMENT_FORMAT } from "../../const";
import moment from "moment";
import OrderService from "../../service/order";
import domtoimage from 'dom-to-image';

const imgScale = {
  width: "24px",
  height: "24px"
};
const Icon = props => (
  <img className={props.className} src={props.src} {...imgScale} />
);

class PersonalStep5 extends Component {
  callBackAction;
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    setTimeout(() => {
      this.onSaveImage();
    }, 1000);
  }

  onSaveImage() {
    const { step4: { paymentModel } } = this.context;
    var node = document.getElementById('capture-wrapper');
    var options = {quality: 1};

    domtoimage.toPng(node, options).then((dataUrl) => {
        OrderService.saveReceipt({
          ref_id: paymentModel.orderId,
          receipt: dataUrl
        })
    });
  }

  render() {
    const { step1, step2, step3, step4 } = this.context;
    const { sStart_date, sEnd_date } = step2;

    const { selectedPlan, planList } = step1;
    const planDetail =
      planList.filter(plan => plan.id === selectedPlan)[0] || {};
    const { insured, total, packageCode } = planDetail;
    const totalAmount = total;
    const { onNavigate, ref_no } = this.context.step5;
    // payment
    const { paymentModel } = this.context.step4;
    return (
      <div id="capture-wrapper" className="form-wrapper payment-wrapper successful">
        <div className="form-group d-flex flex-column flex-1 w-100">
          <Icon
              className="align-item-center w-100 payment-icon"
              src={successful}
            />
          <div className="form-group">
            <div className="successful-reactagle ">
              <label className="text-center">ชำระเบี้ยประกันเรียบร้อย</label>
              <p className="text-center">
                {moment().format(DATETIME_PAYMENT_FORMAT)}
              </p>
            </div>
          </div>
          <div className="form-wrapper successful-wrapper">
            {/* <div className="form-group"> */}
            <div className="form-group">
              <label className="total-value text-center">
                {CurrencyUtils.currency(totalAmount)} บาท
              </label>
            </div>
            <div className="form-group">
              <label className="ref-value text-center mt-0">
                Reference ID {paymentModel.orderId}
              </label>
            </div>
            <hr />
            <div className="form-wrapper">
              <div className="form-group">
                <label>เลขที่ใบสั่งซื้อ</label>
                <label className="order-value" style={{ color: "#ffffff !important"}}>{paymentModel.refNo}</label> {/* get refNo */}
              </div>
              <div className="form-group">
                <label>ผลิตภัณฑ์</label>
                <label className="order-value">ประกันภัยอุบัติเหตุสำหรับคุณ</label>
              </div>
              <div className="form-group">
                <label>แผนประกัน</label>
                <label className="order-value">แผน {packageCode}</label>
              </div>
              <div className="form-group">
                <label>ทุนประกัน</label>
                <label className="order-value">
                  {CurrencyUtils.currency(insured)} บาท
                </label>
              </div>
              {/* <div className="form-group">
                <label>ระยะเวลาเอาประกัน</label>
                <label className="order-value">
                  {moment(sStart_date).format(DATETHAI_FORMAT)} -{" "}
                  {moment(sEnd_date).format(DATETHAI_FORMAT)}
                </label>
              </div> */}
            </div>
          </div>
          {/* </div> */}
          <div className="form-group successful-footer align-item-center">
            <label className="text-wrapper">
              {process.env.NODE_ENV  === 'production' &&
              <>คุณจะได้รับ {parseInt(totalAmount / 25)} AOT Point หลังจาก การซื้อประกันภายใน 15 วัน</>
              }
            </label>
          </div>
          <div className="form-group footer">
            <form id="" method="post" action="">
              <input type="hidden" name="" value="" />
              <input type="hidden" name="" value="" />
              <input type="hidden" name="curency" value="" />
              <input type="hidden" name="" value="" />
              <input type="hidden" name="hash_value" value="" />
            </form>
            <button
              className="successful-btn align-item-center"
              onClick={() => (window.location.href = `/?confirm_pay=${paymentModel.orderId}`)}
            >
              ตกลง
            </button>
          </div>
        </div>
      </div>
    );
  }
}

PersonalStep5.contextType = PersonalContext;
export default PersonalStep5;
